/**
 * Vuex "popup" module (registered as `modals` in the root store).
 *
 * Aggregates visibility flags and payload data for the app's various modal
 * dialogs (auth, org, drafts, replies, quotes, about-us): state (store.js),
 * actions (operations.js), getters (selectors.js), and mutations (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
